// extracted by mini-css-extract-plugin
export default {"ButtonSection":"gridEvento_ButtonSection__AqlDD","UlCuston":"gridEvento_UlCuston__7tifu"};